import { render, staticRenderFns } from "./therapy.vue?vue&type=template&id=62335d00&scoped=true&"
import script from "./therapy.vue?vue&type=script&lang=js&"
export * from "./therapy.vue?vue&type=script&lang=js&"
import style0 from "./therapy.vue?vue&type=style&index=0&id=62335d00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62335d00",
  null
  
)

export default component.exports